import MuiTabs from './MuiTabs';

export default MuiTabs;
